import React from 'react'
import DashboardLayout from "../../layouts/DashboardLayout"
import { Redirect, Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router';

const MapView = React.lazy(() => import("../../MapView"))
const ControlPanel = React.lazy(() => import( "../../ControlPanelView"))
const WeatherView = React.lazy(() => import("../../WeatherView"))
const CalendarView = React.lazy(() => import("../../CalendarView"))

const RegionView = React.lazy(() => import('./region/RegionView'))
const BuildingView = React.lazy(() => import('./building/BuildingView'))
const PostView = React.lazy(() => import('./post/PostView'))

const DailyView = () => {

    const {path} = useRouteMatch()

    return (
        <DashboardLayout>
            <DashboardLayout.TopLeftView>
                <MapView/>
            </DashboardLayout.TopLeftView>
            <DashboardLayout.BottomLeftView>
                <ControlPanel/>
            </DashboardLayout.BottomLeftView>
            <DashboardLayout.TopRightView>
                <WeatherView/>
            </DashboardLayout.TopRightView>
            <DashboardLayout.BottomRightView>
                <CalendarView/>
            </DashboardLayout.BottomRightView>
            <DashboardLayout.MainView>
                <Switch>
                    <Route path={`${path}/building/:buildingCode`}><BuildingView/></Route>
                    <Route path={`${path}/post/:postCode`}><PostView/></Route>
                    <Route path={path}><RegionView/></Route>
                    <Route path={`${path}/*`}><Redirect to={`/`}/></Route>
                </Switch>
            </DashboardLayout.MainView>
        </DashboardLayout>
    )
}

export default DailyView